import {combineReducers} from 'redux';
import userReducer from './user.reducer.js';
import workspaceReducer from './workspace.reducer.js';
import settingReducer from './settings.reducer.js';

export default combineReducers({
    user: userReducer,
    workspace: workspaceReducer,
    settings: settingReducer,
});
